import script from "./reviewMeetings.vue?vue&type=script&setup=true&lang=js"
export * from "./reviewMeetings.vue?vue&type=script&setup=true&lang=js"

import "./reviewMeetings.vue?vue&type=style&index=0&id=a978f472&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a978f472"]])

export default __exports__